// Cities BBox
export const CitiesBBox = {
  "city-kozhikode":
    "75.7153808877278,11.135954220698475,75.84617526198834,11.349441315767068",
};

// kozhikodePoints
const kozhikodePoints = [
  [11.385798, 75.761984, 3],
  [11.222627, 75.851226, 3],
  [11.2684925, 75.805431, 9],
  [11.416136, 75.930327, 14],
  [11.1903283, 75.8283187, 20],
  [11.361555, 75.805668, 21],
  [11.64382973, 75.85705555, 32],
  [11.366899, 76.009577, 34],
  [11.1758247, 75.8259974, 35],
  [11.3042939, 75.801491, 41],
  [11.338404, 75.741484, 43],
  [11.304617, 75.874706, 46],
  [11.385798, 75.761984, 55.556],
  [11.684126, 75.677546, 56],
  [11.1903283, 75.8283187, 61],
  [11.420913, 75.832455, 62],
  [11.1903283, 75.8283187, 83],
  [11.2584085, 75.7856626, 92],
  [11.444647, 75.693532, 93.75],
  [11.254665, 75.793685, 103],
  [11.60429, 75.586583, 120],
  [11.304617, 75.874706, 137],
  [11.361555, 75.805668, 138],
  [11.4863, 76.01291, 139],
  [11.2684925, 75.805431, 139],
  [11.2597885121259, 75.8353494590702, 150],
  [11.272498, 75.841218, 165],
  [11.319819, 75.799663, 179],
  [11.2860705, 75.843111, 180],
  [11.272498, 75.841218, 184],
  [11.60429, 75.586583, 185.8],
  [11.222627, 75.851226, 191],
  [11.2627699, 75.935808, 197],
  [11.450643, 75.758145, 204],
  [11.416136, 75.930327, 215],
  [11.60429, 75.586583, 230],
  [11.2684925, 75.805431, 230],
  [11.6769303, 75.7789151, 248],
  [11.2627275, 75.7755057, 250],
  [11.3218152, 75.9903399, 253],
  [11.246999, 75.784122, 253],
  [11.60429, 75.586583, 268],
  [11.416136, 75.930327, 276],
  [11.254665, 75.793685, 298],
  [11.349764, 75.7605, 306],
  [11.304617, 75.874706, 312],
  [11.215765, 75.798993, 321],
  [11.659993, 75.748157, 344],
  [11.293908, 75.912659, 344],
  [11.66941915, 75.6290057, 352],
  [11.3807243, 75.7236207, 400],
  [11.416136, 75.930327, 400],
  [11.320934, 75.846647, 402],
  [11.2597885121259, 75.8353494590702, 426],
  [11.319819, 75.799663, 431],
  [11.3209424, 75.7505575, 444],
  [11.293908, 75.912659, 459],
  [11.304617, 75.874706, 459],
  [11.304617, 75.874706, 486],
  [11.3218152, 75.9903399, 497],
  [11.304617, 75.874706, 517],
  [11.175347, 75.807355, 522],
  [11.175347, 75.807355, 556],
  [11.272498, 75.841218, 574],
  [11.287949, 75.871331, 574],
  [11.25248, 75.82043, 600],
  [11.43997337, 75.82399547, 643],
  [11.2882115, 75.7535662, 650],
  [11.60429, 75.586583, 689],
  [11.444647, 75.693532, 689],
  [11.1758247, 75.8259974, 689],
  [11.366899, 76.009577, 689],
  [11.316724, 75.976601, 689],
  [11.60429, 75.586583, 765],
  [11.320934, 75.846647, 765],
  [11.245362, 75.806879, 765],
  [11.294542, 75.850003, 785],
  [11.48091, 75.99992, 803],
  [11.60429, 75.586583, 804],
  [11.295799, 75.823342, 804],
  [11.2643175, 75.88568, 804],
  [11.247549, 75.842158, 861],
  [11.517559, 75.621824, 872],
  [11.2882115, 75.7535662, 918],
  [11.304617, 75.874706, 918],
  [11.305519, 75.763455, 918],
  [11.2597885121259, 75.8353494590702, 960],
  [11.272498, 75.841218, 977],
  [11.444647, 75.693532, 1000],
  [11.245362, 75.806879, 1000],
  [11.444647, 75.693532, 1000],
  [11.223089, 75.831974, 1002],
  [11.333956, 75.773033, 1033],
  [11.292949, 75.792429, 1147],
  [11.222627, 75.851226, 1148],
  [11.222627, 75.851226, 1148],
  [11.2860705, 75.843111, 1148],
  [11.338404, 75.741484, 1148],
  [11.222627, 75.851226, 1148],
  [11.187052, 75.871537, 1148],
  [11.1758247, 75.8259974, 1161],
  [11.223089, 75.831974, 1167],
  [11.25248, 75.82043, 1200],
  [11.25248, 75.82043, 1200],
  [11.2684925, 75.805431, 1200],
  [11.3042939, 75.801491, 1205],
  [11.305519, 75.763455, 1205],
  [11.187052, 75.871537, 1248],
  [11.2802589, 75.7819622, 1288],
  [11.2860705, 75.843111, 1332],
  [11.321888, 75.941362, 1333],
  [11.235371, 75.791213, 1341],
  [11.247549, 75.842158, 1345],
  [11.367828, 75.771569, 1359],
  [11.367828, 75.771569, 1359],
  [11.222627, 75.851226, 1377],
  [11.292166, 75.772881, 1378],
  [11.60429, 75.586583, 1378],
  [11.2884609, 75.803135, 1476],
  [11.517559, 75.621824, 1492],
  [11.297888, 75.833138, 1492],
  [11.2706963, 75.789311, 1500],
  [11.27729, 75.810049, 1500],
  [11.6769303, 75.7789151, 1500],
  [11.246999, 75.784122, 1546],
  [11.270947, 75.837413, 1561],
  [11.222627, 75.851226, 1574],
  [11.3218152, 75.9903399, 1607],
  [11.272498, 75.841218, 1607],
  [11.30939777, 75.77818314, 1607],
  [11.293908, 75.912659, 1658],
  [11.27729, 75.810049, 1688],
  [11.60429, 75.586583, 1720],
  [11.245362, 75.806879, 1750],
  [11.2627699, 75.935808, 1799],
  [11.334544, 75.763779, 1800],
  [11.2701322, 75.8302778, 1815],
  [11.3218152, 75.9903399, 1837],
  [11.272498, 75.841218, 1837],
  [11.295799, 75.823342, 1837],
  [11.2261194, 75.7960977, 1837],
  [11.294542, 75.850003, 1894],
  [11.225719, 75.793969, 1894],
  [11.299372, 75.860372, 1906],
  [11.292166, 75.772881, 1907],
  [11.299372, 75.860372, 1913],
  [11.564987, 75.762653, 1928.571],
  [11.30939777, 75.77818314, 1939],
  [11.2802589, 75.7819622, 1952],
  [11.444647, 75.693532, 2000],
  [11.175347, 75.807355, 2009],
  [11.288877, 75.7850955, 2066],
  [11.60429, 75.586583, 2087],
  [11.2802589, 75.7819622, 2104.348],
  [11.2802589, 75.7819622, 2104.348],
  [11.2802589, 75.7819622, 2104.348],
  [11.2701322, 75.8302778, 2210],
  [11.3042939, 75.7873067, 2250],
  [11.3042939, 75.7873067, 2273],
  [11.3042939, 75.7873067, 2273],
  [11.3042939, 75.7873067, 2273],
  [11.3042939, 75.7873067, 2273],
  [11.2860705, 75.843111, 2296],
  [11.439076, 75.818293, 2296],
  [11.2684925, 75.805431, 2296],
  [11.27729, 75.810049, 2296],
  [11.309673, 75.755487, 2296],
  [11.288877, 75.7850955, 2296],
  [11.269074, 75.792765, 2296],
  [11.2684925, 75.805431, 2381],
  [11.2673673, 75.7621688, 2411],
  [11.1758247, 75.8259974, 2467],
  [11.2627699, 75.935808, 2500],
  [11.2597885121259, 75.8353494590702, 2526],
  [11.2701322, 75.8302778, 2551],
  [11.1903283, 75.8283187, 2551],
  [11.25163, 75.81881, 2568],
  [11.264869, 75.788008, 2571],
  [11.264869, 75.788008, 2571],
  [11.305519, 75.763455, 2640],
  [11.175347, 75.807355, 2650],
  [11.287949, 75.871331, 2650],
  [11.27729, 75.810049, 2667],
  [11.2584085, 75.7856626, 2747],
  [11.2584085, 75.7856626, 2747],
  [11.2684925, 75.805431, 2755],
  [11.2882115, 75.7535662, 2755],
  [11.225719, 75.793969, 2755],
  [11.36721, 75.862965, 2800],
  [11.319819, 75.799663, 2826],
  [11.240993, 75.7895115, 2857],
  [11.28409, 75.78101, 2870],
  [11.2722899, 75.8159578, 2872],
  [11.2643175, 75.88568, 2917],
  [11.2627699, 75.935808, 2923],
  [11.2701322, 75.8302778, 2927],
  [11.43997337, 75.82399547, 2931],
  [11.3042939, 75.7873067, 2947],
  [11.3042939, 75.7873067, 2955],
  [11.254665, 75.793685, 2973],
  [11.254665, 75.793685, 2984],
  [11.2684925, 75.805431, 2985],
  [11.2722899, 75.8159578, 2985],
  [11.306577, 75.82276, 2999],
  [11.240993, 75.7895115, 2999],
  [11.30459278, 75.83434863, 3056],
  [11.2882115, 75.7535662, 3061],
  [11.227806, 75.810045, 3077],
  [11.254665, 75.793685, 3131],
  [11.416136, 75.930327, 3157],
  [11.4960259, 75.8112925, 3188],
  [11.207694, 75.794994, 3200],
  [11.2730489, 75.7757937, 3214],
  [11.272498, 75.841218, 3214],
  [11.220705, 75.797595, 3263],
  [11.402735, 75.727172, 3267],
  [11.2884609, 75.803135, 3333],
  [11.220705, 75.797595, 3395],
  [11.304617, 75.874706, 3398],
  [11.2730489, 75.7757937, 3444],
  [11.175347, 75.807355, 3455],
  [11.293908, 75.912659, 3492],
  [11.2706963, 75.789311, 3500],
  [11.222627, 75.851226, 3500],
  [11.2261194, 75.7960977, 3500],
  [11.2882115, 75.7535662, 3538],
  [11.2627699, 75.935808, 3556],
  [11.175347, 75.807355, 3636],
  [11.175347, 75.807355, 3636],
  [11.175347, 75.807355, 3636],
  [11.175347, 75.807355, 3636],
  [11.245362, 75.806879, 3674],
  [11.235371, 75.791213, 3674],
  [11.272498, 75.841218, 3696],
  [11.175347, 75.807355, 3750],
  [11.2684925, 75.805431, 3750],
  [11.247549, 75.842158, 3800],
  [11.2884609, 75.803135, 3826],
  [11.254665, 75.793685, 3827],
  [11.3042939, 75.801491, 3828],
  [11.2860705, 75.843111, 3831],
  [11.276616, 75.890307, 3878],
  [11.416136, 75.930327, 3903],
  [11.223089, 75.831974, 3903],
  [11.305519, 75.763455, 3966],
  [11.297888, 75.833138, 4000],
  [11.19841135, 75.86726707, 4000],
  [11.304617, 75.874706, 4000],
  [11.306577, 75.82276, 4000],
  [11.245362, 75.806879, 4000],
  [11.26998, 75.78076, 4062],
  [11.245362, 75.806879, 4071],
  [11.304617, 75.874706, 4091],
  [11.19841135, 75.86726707, 4133],
  [11.2730489, 75.7757937, 4133],
  [11.272498, 75.841218, 4167],
  [11.2884609, 75.803135, 4167],
  [11.238144, 75.812459, 4174],
  [11.238144, 75.812459, 4174],
  [11.238144, 75.812459, 4174],
  [11.238144, 75.812459, 4174],
  [11.238144, 75.812459, 4174],
  [11.238144, 75.812459, 4175],
  [11.238144, 75.812459, 4175],
  [11.238144, 75.812459, 4175],
  [11.238144, 75.812459, 4175],
  [11.3218152, 75.9903399, 4180],
  [11.3042939, 75.801491, 4182],
  [11.297888, 75.833138, 4195],
  [11.297888, 75.833138, 4195],
  [11.297888, 75.833138, 4195],
  [11.297888, 75.833138, 4195],
  [11.309673, 75.755487, 4209],
  [11.222627, 75.851226, 4273],
  [11.222627, 75.851226, 4301],
  [11.225719, 75.793969, 4319],
  [11.294542, 75.850003, 4333],
  [11.254665, 75.793685, 4337],
  [11.2261194, 75.7960977, 4364],
  [11.272498, 75.841218, 4375],
  [11.295864, 75.814257, 4397],
  [11.175347, 75.807355, 4400],
  [11.292166, 75.772881, 4444],
  [11.245362, 75.806879, 4455],
  [11.292949, 75.792429, 4474],
  [11.240993, 75.7895115, 4480],
  [11.2884609, 75.803135, 4500],
  [11.3042939, 75.7873067, 4500],
  [11.247549, 75.842158, 4533],
  [11.247549, 75.842158, 4533],
  [11.247549, 75.842158, 4533],
  [11.2706963, 75.789311, 4579],
  [11.2389, 75.80161, 4583],
  [11.292166, 75.772881, 4591],
  [11.26392, 75.79471, 4591],
  [11.2684925, 75.805431, 4592],
  [11.2584085, 75.7856626, 4592],
  [11.2584085, 75.7856626, 4592],
  [11.235371, 75.791213, 4592],
  [11.2884609, 75.803135, 4592],
  [11.2261194, 75.7960977, 4592],
  [11.25248, 75.82043, 4615],
  [11.270947, 75.837413, 4667],
  [11.444647, 75.693532, 4667],
  [11.2884609, 75.803135, 4700],
  [11.2884609, 75.803135, 4700],
  [11.2884609, 75.803135, 4700],
  [11.2884609, 75.803135, 4700],
  [11.2884609, 75.803135, 4700],
  [11.295864, 75.814257, 4722],
  [11.305519, 75.763455, 4800],
  [11.2802589, 75.7819622, 4831],
  [11.2673673, 75.7621688, 5000],
  [11.235371, 75.791213, 5000],
  [11.238144, 75.812459, 5000],
  [11.26392, 75.79471, 5000],
  [11.225719, 75.793969, 5026],
  [11.258945, 75.781036, 5057],
  [11.222627, 75.851226, 5062],
  [11.187052, 75.871537, 5152],
  [11.27729, 75.810049, 5158],
  [11.295799, 75.823342, 5188],
  [11.28712, 75.79542, 5198],
  [11.2597885121259, 75.8353494590702, 5263],
  [11.2882115, 75.7535662, 5312],
  [11.272498, 75.841218, 5385],
  [11.2884609, 75.803135, 5417],
  [11.2884609, 75.803135, 5417],
  [11.2884609, 75.803135, 5417],
  [11.222627, 75.851226, 5455],
  [11.305519, 75.763455, 5500],
  [11.543637, 75.840402, 5500],
  [11.2884609, 75.803135, 5556],
  [11.175347, 75.807355, 5556],
  [11.264869, 75.788008, 5571],
  [11.295799, 75.823342, 5625],
  [11.26998, 75.78076, 5655],
  [11.2261194, 75.7960977, 5667],
  [11.175347, 75.807355, 5714],
  [11.215765, 75.798993, 5740],
  [11.2730489, 75.7757937, 5740],
  [11.292949, 75.792429, 5745],
  [11.444647, 75.693532, 5767],
  [11.25337, 75.8010331, 5789],
  [11.25248, 75.82043, 5800],
  [11.2884609, 75.803135, 5926],
  [11.2802589, 75.7819622, 5952],
  [11.25337, 75.8010331, 5963],
  [11.258945, 75.781036, 6000],
  [11.2802589, 75.7819622, 6000],
  [11.2584085, 75.7856626, 6000],
  [11.2584085, 75.7856626, 6000],
  [11.2701322, 75.8302778, 6000],
  [11.2701322, 75.8302778, 6000],
  [11.2701322, 75.8302778, 6000],
  [11.1758247, 75.8259974, 6000],
  [11.2701322, 75.8302778, 6061],
  [11.2701322, 75.8302778, 6061],
  [11.2701322, 75.8302778, 6061],
  [11.247549, 75.842158, 6107],
  [11.269476, 75.780974, 6198],
  [11.416136, 75.930327, 6207],
  [11.295799, 75.823342, 6250],
  [11.245362, 75.806879, 6286],
  [11.2684925, 75.805431, 6360],
  [11.292166, 75.772881, 6373],
  [11.288877, 75.7850955, 6401],
  [11.2684925, 75.805431, 6438],
  [11.2706963, 75.789311, 6449],
  [11.25566, 75.77729, 6464.15],
  [11.2597885121259, 75.8353494590702, 6471],
  [11.2597885121259, 75.8353494590702, 6471],
  [11.2597885121259, 75.8353494590702, 6471],
  [11.2597885121259, 75.8353494590702, 6471],
  [11.2597885121259, 75.8353494590702, 6471],
  [11.2597885121259, 75.8353494590702, 6471],
  [11.2597885121259, 75.8353494590702, 6471],
  [11.247549, 75.842158, 6475],
  [11.247549, 75.842158, 6475],
  [11.247549, 75.842158, 6475],
  [11.2684925, 75.805431, 6500],
  [11.25337, 75.8010331, 6533],
  [11.247549, 75.842158, 6720],
  [11.247549, 75.842158, 6720],
  [11.247549, 75.842158, 6720],
  [11.2684925, 75.805431, 6723],
  [11.247549, 75.842158, 6754],
  [11.2684925, 75.805431, 6800],
  [11.48091, 75.99992, 6833],
  [11.2706963, 75.789311, 6836],
  [11.245362, 75.806879, 6887],
  [11.25566, 75.77729, 6888],
  [11.292949, 75.792429, 6958],
  [11.292949, 75.792429, 6958],
  [11.238144, 75.812459, 6979],
  [11.2261194, 75.7960977, 7000],
  [11.269476, 75.780974, 7018],
  [11.2884609, 75.803135, 7083],
  [11.2884609, 75.803135, 7083],
  [11.2884609, 75.803135, 7083],
  [11.2884609, 75.803135, 7083],
  [11.247549, 75.842158, 7107],
  [11.236215, 75.824825, 7192],
  [11.236215, 75.824825, 7192],
  [11.236215, 75.824825, 7192],
  [11.269074, 75.792765, 7213],
  [11.270947, 75.837413, 7249],
  [11.564987, 75.762653, 7411],
  [11.2722899, 75.8159578, 7472],
  [11.292166, 75.772881, 7500],
  [11.2261194, 75.7960977, 7500],
  [11.2722899, 75.8159578, 7533],
  [11.264869, 75.788008, 7605],
  [11.2802589, 75.7819622, 7609],
  [11.246999, 75.784122, 7692],
  [11.236215, 75.824825, 7742],
  [11.247549, 75.842158, 7750],
  [11.295799, 75.823342, 7750],
  [11.240993, 75.7895115, 7759],
  [11.2722899, 75.8159578, 7868],
  [11.222627, 75.851226, 7885],
  [11.2684925, 75.805431, 7925],
  [11.258945, 75.781036, 7954],
  [11.258945, 75.781036, 7954],
  [11.258945, 75.781036, 7954],
  [11.2882115, 75.7535662, 8000],
  [11.2882115, 75.7535662, 8000],
  [11.2882115, 75.7535662, 8000],
  [11.2882115, 75.7535662, 8000],
  [11.2684925, 75.805431, 8000],
  [11.416136, 75.930327, 8000],
  [11.2882115, 75.7535662, 8039],
  [11.2882115, 75.7535662, 8039],
  [11.2882115, 75.7535662, 8039],
  [11.263193, 75.873601, 8106],
  [11.222627, 75.851226, 8118],
  [11.2882115, 75.7535662, 8197],
  [11.27729, 75.810049, 8223],
  [11.263193, 75.873601, 8315],
  [11.263193, 75.873601, 8315],
  [11.263193, 75.873601, 8315],
  [11.305519, 75.763455, 8411],
  [11.2730489, 75.7757937, 8451],
  [11.247549, 75.842158, 8551],
  [11.247549, 75.842158, 8551],
  [11.247549, 75.842158, 8551],
  [11.2802589, 75.7819622, 8571],
  [11.222627, 75.851226, 8571],
  [11.2884609, 75.803135, 8824],
  [11.36721, 75.862965, 8896],
  [11.2882115, 75.7535662, 8920],
  [11.2627699, 75.935808, 9053],
  [11.2597885121259, 75.8353494590702, 9167],
  [11.254329, 75.816168, 9215],
  [11.2882115, 75.7535662, 9403],
  [11.2882115, 75.7535662, 9403],
  [11.2882115, 75.7535662, 9403],
  [11.2722899, 75.8159578, 9412],
  [11.2882115, 75.7535662, 9500],
  [11.2684925, 75.805431, 9600],
  [11.2882115, 75.7535662, 9836],
  [11.2884609, 75.803135, 9863],
  [11.2884609, 75.803135, 9863],
  [11.2884609, 75.803135, 9863],
  [11.263193, 75.873601, 9945],
  [11.3218152, 75.9903399, 10000],
  [11.292949, 75.792429, 10000],
  [11.292949, 75.792429, 10000],
  [11.2261194, 75.7960977, 10000],
  [11.2673673, 75.7621688, 10383],
  [11.272498, 75.841218, 10520],
  [11.2389, 75.80161, 10600],
  [11.258326, 75.77767, 10714],
  [11.25566, 75.77729, 10901],
  [11.2584085, 75.7856626, 12000],
  [11.450643, 75.758145, 12500],
  [11.263193, 75.873601, 13108],
  [11.263193, 75.873601, 13108],
  [11.263193, 75.873601, 13108],
  [11.222627, 75.851226, 15385],
  [11.215765, 75.798993, 15417],
  [11.269476, 75.780974, 16667],
  [11.246999, 75.784122, 16667],
  [11.361555, 75.805668, 17220],
  [11.2730489, 75.7757937, 18000],
  [11.222627, 75.851226, 18889],
  [11.266469, 75.836102, 20000],
  [11.266469, 75.836102, 20000],
  [11.306577, 75.82276, 20000],
  [11.238144, 75.812459, 20087],
  [11.2684925, 75.805431, 23077],
  [11.253576, 75.787018, 23333],
  [11.2467, 75.82871, 23913],
  [11.2684925, 75.805431, 30154],
  [11.247549, 75.842158, 30555],
  [11.247549, 75.842158, 30555],
  [11.247549, 75.842158, 30555],
  [11.247549, 75.842158, 30555],
  [11.336328, 76.111157, 32000],
];

/**
 * Cities Restaurants Data
 */
export const CitiesRestaurantsData = {
  [CitiesBBox["city-kozhikode"]]: {
    statusCode: 200,
    result: {
      type: "restaurant",
      points: [...kozhikodePoints, ...kozhikodePoints], // doubling for better heatmap
      stats: {
        max: 32000,
        min: 3,
        property: "cost-for-two",
        percentiles: {
          5: 149,
          10: 390,
          15: 765,
          20: 1156,
          25: 1554,
          30: 2004,
          35: 2551,
          40: 2975,
          45: 3504,
          50: 4000,
          55: 4298,
          60: 4592,
          65: 5297,
          70: 6000,
          75: 6471,
          80: 7083,
          85: 7954,
          90: 8838,
          95: 11011,
        },
      },
    },
  },
};
